import { createFileRoute } from '@tanstack/react-router'
import { AdminOverviewPage } from '~/pages/admin/admin-overview-page'
import { OverviewPage } from '~/pages/org/overview-page'
import { useOrg } from '~/contexts/org-context'

export const Route = createFileRoute('/org/$org/')({
  component: OrgIndexPage,
})

function OrgIndexPage() {
  const { activeOrgId, isAdminMode } = useOrg()

  if (isAdminMode && activeOrgId) {
    return <AdminOverviewPage organizationId={activeOrgId} />
  }

  return <OverviewPage />
}
